import React from "react";
import PropTypes from "prop-types";
import Paragraph from "../Paragraph";

export const Caps = ({ size = "cap-14", text, ...props }) => {
  return <Paragraph size={size} text={text} {...props} />;
};

Caps.propTypes = {
  size: PropTypes.oneOf(["cap-12", "cap-14", "cap-18"]),
  text: PropTypes.string.isRequired,
};

